import React from 'react'
import styles from '@src/routes/SemiConfigurators/utils/styles'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import messages from '../messages'

const DiscountMessagePage = () => {
  const classes = styles()
  return (
    <>
      <div className={classes.discountMsgCss}>
        <div className={classes.greenRectangle}></div>
        <div className={classes.dFlex}>
          <div className={classes.discountTxtCSS}>
            <img
              className={classes.discountIcon}
              src="/static/discount_icon.svg"
              alt="Discount icon"
            />
          </div>
          <span className={clsx(classes.discountTxtCSS, classes.pdLeft)}>
            <FormattedMessage {...messages.CONF_DISCOUNT_MESSAGE} />
          </span>
        </div>
      </div>
    </>
  )
}

export default DiscountMessagePage
